import { render, staticRenderFns } from "./user-edit.vue?vue&type=template&id=cb0bdf50&"
import script from "./user-edit.vue?vue&type=script&lang=js&"
export * from "./user-edit.vue?vue&type=script&lang=js&"
import style0 from "./user-edit.vue?vue&type=style&index=0&id=cb0bdf50&prod&lang=scss&"
import style1 from "./user-edit.vue?vue&type=style&index=1&id=cb0bdf50&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports